export const LOAD_PRODUCTION_RECORDS_REQUEST = 'LOAD_PRODUCTION_RECORDS_REQUEST';
export const LOAD_PRODUCTION_RECORDS_SUCCESS = 'LOAD_PRODUCTION_RECORDS_SUCCESS';
export const LOAD_PRODUCTION_RECORDS_FAILURE = 'LOAD_PRODUCTION_RECORDS_FAILURE';

export const IMPORT_C5_PRODUCTIONS_REQUEST = 'IMPORT_C5_PRODUCTIONS_REQUEST';
export const IMPORT_C5_PRODUCTIONS_SUCCESS = 'IMPORT_C5_PRODUCTIONS_SUCCESS';
export const IMPORT_C5_PRODUCTIONS_FAILURE = 'IMPORT_C5_PRODUCTIONS_FAILURE';


